import { z } from 'zod'

export const edySupportCaseSearchSchema = z.object({
  search: z.string().max(200).optional().catch(undefined),
  supportUserId: z.string().max(200).optional().catch(undefined),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z.enum(['started', 'casenr', 'supportuser', 'user', 'email']).catch('started'),
  direction: z.enum(['asc', 'desc']).catch('desc'),
})

export type EdySupportCaseSearch = z.infer<typeof edySupportCaseSearchSchema>

export const defaultEdySupportCaseSearch: EdySupportCaseSearch = {
  page: 1,
  pageSize: 10,
  sortBy: 'started',
  direction: 'desc',
}
